export function isTestEnv() {
  return process.env.NODE_ENV === 'test';
}

export function isNotTestEnv() {
  return process.env.NODE_ENV !== 'test';
}

export function isDiscoDevelopmentEnv() {
  return process.env.NODE_ENV === 'development' && window.location.origin === 'https://disco-ui.devo.test';
}

export function isPreviewEnv() {
  return window.location.origin === 'https://preview.reverb.tools';
}
